import { deliveryStatusStyle } from '@bingads-webui-campaign-react/common-styles';

export const getAudienceStatusStyle = (_, { palette = {} }) => ({
  '@global': {
    '#delivery-status-popup-callout': {
      zIndex: 10000000, // Need a z-index higher than the z-index of Fluent UI Panel
    },
    ...deliveryStatusStyle({ palette }),
  },

  statusContainer: {
    '& .underline': {
      borderBottomColor: palette.themePrimary,
      borderBottomStyle: 'dashed',
      borderBottomWidth: 1,
    },
  },
});
